export default "__VITE_ASSET__44fcd20d__"